import React, { useEffect } from 'react';
import { Routes, Route, useSearchParams, useNavigate } from 'react-router-dom';
import './App.css';
import { Box } from '@mui/material';
import Loading from './components/Loading';
import ResourcesPage from './Pages/Resources';
import { useAuth } from './services/useAuth';

const App: React.FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();

  const tokenParam = searchParams.get('token')?.replace(/^-/, '') || undefined;
  const RefreshTokenParam = searchParams.get('refreshToken')?.replace(/^-/, '') || undefined;

  const auth = useAuth(tokenParam, RefreshTokenParam);

  // 🧹 Clear URL query params after authentication
  useEffect(() => {
    if ((tokenParam || RefreshTokenParam) && auth.isValid) {
      const params = new URLSearchParams(searchParams);
      params.delete('token');
      params.delete('refreshToken');
      navigate(
        {
          pathname: window.location.pathname,
          search: params.toString(),
        }
      );
    }
  }, [auth.isValid, tokenParam, RefreshTokenParam, navigate, searchParams]);

  if (!auth.isValid) {
    return <Loading />; // or redirect to login
  }

  return (
    // No top bar — the sidebar carries the brand and the language/theme toggles,
    // and the page fills the full viewport width.
    <Box className="App" sx={{ height: '100vh', overflow: 'hidden', display: 'flex', flexDirection: 'column' }}>
      <Box sx={{ flex: 1, overflow: 'hidden' }}>
        <Routes>
          <Route path="/" element={<ResourcesPage />} />
        </Routes>
      </Box>
    </Box>
  );
};

export default App;
